import React, { useState, useEffect } from "react";
import api from "../api";
import Table from "../components/Table";
import Modal from "../components/Modal";
import ImageUpload from "../components/ImageUpload";
import { FiPlus, FiTrash2, FiCalendar, FiUsers, FiTag, FiAward, FiUser,FiLink,FiBookOpen,FiBriefcase } from "react-icons/fi";
import toast from "react-hot-toast";
const FormGroup = ({ children, cols = 1 }) => {
  const colClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-3',
  };
  return (
    <div className={`grid ${colClasses[cols]} gap-6 mb-6`}>
      {children}
    </div>
  );
};

const InputField = ({ icon, label, name, type = 'text', value, onChange, required = true }) => (
  <div>
    <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">
      {label}
    </label>
    <div className="mt-1 relative rounded-md shadow-sm">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        {icon}
      </div>
      <input
        type={type}
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
        required={required}
      />
    </div>
  </div>
);
const Hackathons = () => {
  const [hackathons, setHackathons] = useState([]);
  const [colleges, setColleges] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentHackathon, setCurrentHackathon] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    startDate: "",
    endDate: "",
    organizer: "",
    participantCount: 0,
    teams: [],
    tags: [],
    images: [],
    logo: "",
    level: "",
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    pages: 0,
  });
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchHackathons();
    fetchColleges();
  }, [pagination.page, pagination.limit, searchTerm]);

  const fetchHackathons = async () => {
    try {
      const response = await api.get("/hackathon", {
        params: {
          page: pagination.page,
          limit: pagination.limit,
          search: searchTerm,
        },
      });
      setHackathons(response.data.data);
      setPagination(prevState => ({
        ...prevState,
        total: response.data.pagination.total,
        pages: response.data.pagination.pages,
      }));
    } catch (error) {
      toast.error("Failed to fetch hackathons");
    }
  };

  const fetchColleges = async () => {
    try {
      const response = await api.get("/college");
      setColleges(response.data.data);
    } catch (error) {
      toast.error("Failed to fetch colleges");
    }
  };

  const handlePageChange = (newPage) => {
    setPagination(prevState => ({ ...prevState, page: newPage }));
  };

  const handleLimitChange = (newLimit) => {
    setPagination(prevState => ({ ...prevState, limit: newLimit, page: 1 }));
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setPagination(prevState => ({ ...prevState, page: 1 }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: name === "participantCount" ? parseInt(value) : value,
    }));
  };

  const handleTagsChange = (e) => {
    const tags = e.target.value.split(",").map((tag) => tag.trim());
    setFormData((prevState) => ({ ...prevState, tags }));
  };

  const handleImageUpload = (urls) => {
    setFormData((prevState) => ({
      ...prevState,
      images: [...prevState.images, ...urls],
    }));
  };

  const handleImageRemove = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      images: prevState.images.filter((_, i) => i !== index),
    }));
  };

  const handleLogoUpload = (urls) => {
    setFormData((prevState) => ({ ...prevState, logo: urls[0] }));
  };

  const handleLogoRemove = () => {
    setFormData((prevState) => ({ ...prevState, logo: "" }));
  };

  const handleTeamChange = (index, field, value) => {
    const updatedTeams = [...formData.teams];
    updatedTeams[index] = { ...updatedTeams[index], [field]: value };
    setFormData((prevState) => ({ ...prevState, teams: updatedTeams }));
  };

  const handleParticipantChange = (
    teamIndex,
    participantIndex,
    field,
    value
  ) => {
    const updatedTeams = [...formData.teams];
    updatedTeams[teamIndex].participants[participantIndex] = {
      ...updatedTeams[teamIndex].participants[participantIndex],
      [field]: value,
    };
    setFormData((prevState) => ({ ...prevState, teams: updatedTeams }));
  };

  const addTeam = () => {
    setFormData((prevState) => ({
      ...prevState,
      teams: [
        ...prevState.teams,
        {
          name: "",
          participants: [],
          teamPhoto: "",
          position: "participant",
          prizeWon: "",
          college: "",
        },
      ],
    }));
  };

  const removeTeam = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      teams: prevState.teams.filter((_, i) => i !== index),
    }));
  };

  const addParticipant = (teamIndex) => {
    const updatedTeams = [...formData.teams];
    updatedTeams[teamIndex].participants.push({
      name: "",
      photo: "",
      linkedinUrl: "",
    });
    setFormData((prevState) => ({ ...prevState, teams: updatedTeams }));
  };

  const removeParticipant = (teamIndex, participantIndex) => {
    const updatedTeams = [...formData.teams];
    updatedTeams[teamIndex].participants = updatedTeams[
      teamIndex
    ].participants.filter((_, i) => i !== participantIndex);
    setFormData((prevState) => ({ ...prevState, teams: updatedTeams }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (currentHackathon) {
        await api.put(`/hackathon/${currentHackathon._id}`, formData);
        toast.success("Hackathon updated successfully");
      } else {
        await api.post("/hackathon", formData);
        toast.success("Hackathon created successfully");
      }
      setIsModalOpen(false);
      fetchHackathons();
    } catch (error) {
      toast.error("Failed to save hackathon");
    }
  };

  const handleEdit = (hackathon) => {
    setCurrentHackathon(hackathon);
    setFormData({
      name: hackathon.name,
      description: hackathon.description,
      startDate: hackathon.startDate.split("T")[0],
      endDate: hackathon.endDate.split("T")[0],
      organizer: hackathon.organizer,
      participantCount: hackathon.participantCount,
      teams: hackathon.teams,
      tags: hackathon.tags,
      images: hackathon.images,
      logo: hackathon.logo,
      level: hackathon.level,
    });
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this hackathon?")) {
      try {
        await api.delete(`/hackathon/${id}`);
        toast.success("Hackathon deleted successfully");
        fetchHackathons();
      } catch (error) {
        toast.error("Failed to delete hackathon");
      }
    }
  };

  const columns = [
    { key: "name", label: "Name" },
    {
      key: "startDate",
      label: "Start Date",
      render: (item) => new Date(item.startDate).toLocaleDateString(),
    },
    {
      key: "endDate",
      label: "End Date",
      render: (item) => new Date(item.endDate).toLocaleDateString(),
    },
    { key: "organizer", label: "Organizer" },
    { key: "participantCount", label: "Participants" },
    { key: "level", label: "Level" },
  ];



  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Hackathons</h1>
        <button
          onClick={() => {
            setCurrentHackathon(null);
            setFormData({
              name: "",
              description: "",
              startDate: "",
              endDate: "",
              organizer: "",
              participantCount: 0,
              teams: [],
              tags: [],
              images: [],
              logo: "",
              level: "",
            });
            setIsModalOpen(true);
          }}
          className="px-4 py-2 font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-150 ease-in-out"
        >
          <FiPlus className="inline-block mr-2" />
          Add Hackathon
        </button>
      </div>
      <Table
        columns={columns}
        data={hackathons}
        onEdit={handleEdit}
        onDelete={handleDelete}
        pagination={pagination}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        onSearch={handleSearch}
      />
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={currentHackathon ? "Edit Hackathon" : "Add Hackathon"}
        size="xl"
      >
        <form onSubmit={handleSubmit} className="space-y-6">
          <FormGroup cols={2}>
            <InputField
              icon={<FiCalendar className="h-5 w-5 text-gray-400" />}
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
            />
            <InputField
              icon={<FiUsers className="h-5 w-5 text-gray-400" />}
              label="Organizer"
              name="organizer"
              value={formData.organizer}
              onChange={handleInputChange}
            />
          </FormGroup>
          <FormGroup>
            <div>
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">Description</label>
              <textarea
                id="description"
                name="description"
                rows="3"
                value={formData.description}
                onChange={handleInputChange}
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              ></textarea>
            </div>
          </FormGroup>
          <FormGroup cols={2}>
            <InputField
              icon={<FiCalendar className="h-5 w-5 text-gray-400" />}
              label="Start Date"
              name="startDate"
              type="date"
              value={formData.startDate}
              onChange={handleInputChange}
            />
            <InputField
              icon={<FiCalendar className="h-5 w-5 text-gray-400" />}
              label="End Date"
              name="endDate"
              type="date"
              value={formData.endDate}
              onChange={handleInputChange}
            />
          </FormGroup>
          <FormGroup cols={3}>
            <InputField
              icon={<FiUsers className="h-5 w-5 text-gray-400" />}
              label="Participant Count"
              name="participantCount"
              type="number"
              value={formData.participantCount}
              onChange={handleInputChange}
            />
            <InputField
              icon={<FiTag className="h-5 w-5 text-gray-400" />}
              label="Tags (comma-separated)"
              name="tags"
              value={formData.tags.join(", ")}
              onChange={handleTagsChange}
            />
            <InputField
              icon={<FiAward className="h-5 w-5 text-gray-400" />}
              label="Level"
              name="level"
              value={formData.level}
              onChange={handleInputChange}
            />
          </FormGroup>
          <FormGroup cols={2}>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Logo</label>
              <ImageUpload
                onUpload={handleLogoUpload}
                onRemove={handleLogoRemove}
                images={formData.logo ? [formData.logo] : []}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Images</label>
              <ImageUpload
                onUpload={handleImageUpload}
                onRemove={handleImageRemove}
                images={formData.images}
                multiple
              />
            </div>
          </FormGroup>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Teams</label>
            {formData.teams.map((team, teamIndex) => (
              <div key={teamIndex} className="border p-4 mb-4 rounded">
                <div className="flex justify-between items-center mb-2">
                  <h4 className="text-lg font-medium">Team {teamIndex + 1}</h4>
                  <button
                    type="button"
                    onClick={() => removeTeam(teamIndex)}
                    className="text-red-600 hover:text-red-800"
                  >
                    <FiTrash2 />
                  </button>
                </div>
                <FormGroup cols={2}>
                  <InputField
                    icon={<FiUsers className="h-5 w-5 text-gray-400" />}
                    label="Team Name"
                    name={`team-${teamIndex}-name`}
                    value={team.name}
                    onChange={(e) => handleTeamChange(teamIndex, "name", e.target.value)}
                  />
                   <InputField
                    icon={<FiBookOpen className="h-5 w-5 text-gray-400" />}
                    label="Team Description"
                    name={`team-${teamIndex}-description`}
                    value={team.description}
                    onChange={(e) => handleTeamChange(teamIndex, "description", e.target.value)}
                  />
                  <div>
                    <label htmlFor={`team-${teamIndex}-position`} className="block text-sm font-medium text-gray-700 mb-1">Position</label>
                    <div className="mt-1 relative rounded-md shadow-sm">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <FiAward className="h-5 w-5 text-gray-400" />
                      </div>
                      <select
                        id={`team-${teamIndex}-position`}
                        value={team.position}
                        onChange={(e) => handleTeamChange(teamIndex, "position", e.target.value)}
                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                      >
                        <option value="participant">Participant</option>
                        <option value="finalist">Finalist</option>
                        <option value="winner">Winner</option>
                      </select>
                    </div>
                  </div>
                </FormGroup>
                <FormGroup cols={2}>
                  <InputField
                    icon={<FiAward className="h-5 w-5 text-gray-400" />}
                    label="Prize Won"
                    name={`team-${teamIndex}-prizeWon`}
                    value={team.prizeWon}
                    onChange={(e) => handleTeamChange(teamIndex, "prizeWon", e.target.value)}
                  />
                  <div>
                    <label htmlFor={`team-${teamIndex}-college`} className="block text-sm font-medium text-gray-700 mb-1">College</label>
                    <div className="mt-1 relative rounded-md shadow-sm">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <FiUsers className="h-5 w-5 text-gray-400" />
                      </div>
                      <select
                        id={`team-${teamIndex}-college`}
                        value={team.college}
                        onChange={(e) => handleTeamChange(teamIndex, "college", e.target.value)}
                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                      >
                        <option value="">Select College</option>
                        {colleges.map((college) => (
                          <option key={college._id} value={college._id}>
                            {college.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </FormGroup>
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Team Photo</label>
                  <ImageUpload
                    onUpload={(urls) => handleTeamChange(teamIndex, "teamPhoto", urls[0])}
                    onRemove={() => handleTeamChange(teamIndex, "teamPhoto", "")}
                    images={team.teamPhoto ? [team.teamPhoto] : []}
                  />
                </div>
                <h5 className="mt-6 mb-2 font-medium">Participants</h5>
                {team.participants.map((participant, participantIndex) => (
                  <div key={participantIndex} className="border-t pt-4 mb-4">
                    <div className="flex justify-between items-center mb-2">
                      <h6 className="text-sm font-medium">Participant {participantIndex + 1}</h6>
                      <button
                        type="button"
                        onClick={() => removeParticipant(teamIndex, participantIndex)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <FiTrash2 />
                      </button>
                    </div>
                    <FormGroup cols={2}>
                      <InputField
                        icon={<FiUser className="h-5 w-5 text-gray-400" />}
                        label="Name"
                        name={`team-${teamIndex}-participant-${participantIndex}-name`}
                        value={participant.name}
                        onChange={(e) => handleParticipantChange(teamIndex, participantIndex, "name", e.target.value)}
                      />
                      <InputField
                        icon={<FiLink className="h-5 w-5 text-gray-400" />}
                        label="LinkedIn URL"
                        name={`team-${teamIndex}-participant-${participantIndex}-linkedinUrl`}
                        value={participant.linkedinUrl}
                        onChange={(e) => handleParticipantChange(teamIndex, participantIndex, "linkedinUrl", e.target.value)}
                      />
                    </FormGroup>
                    <FormGroup cols={2}>
                      <InputField
                        icon={<FiCalendar className="h-5 w-5 text-gray-400" />}
                        label="Batch Year"
                        name={`team-${teamIndex}-participant-${participantIndex}-batchYear`}
                        value={participant.batchYear}
                        onChange={(e) => handleParticipantChange(teamIndex, participantIndex, "batchYear", e.target.value)}
                      />
                      <InputField
                        icon={<FiBriefcase className="h-5 w-5 text-gray-400" />}
                        label="Department"
                        name={`team-${teamIndex}-participant-${participantIndex}-department`}
                        value={participant.department}
                        onChange={(e) => handleParticipantChange(teamIndex, participantIndex, "department", e.target.value)}
                      />
                    </FormGroup>
                    <div className="mt-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Photo</label>
                      <ImageUpload
                        onUpload={(urls) => handleParticipantChange(teamIndex, participantIndex, "photo", urls[0])}
                        onRemove={() => handleParticipantChange(teamIndex, participantIndex, "photo", "")}
                        images={participant.photo ? [participant.photo] : []}
                      />
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={() => addParticipant(teamIndex)}
                  className="mt-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Add Participant
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={addTeam}
              className="mt-4 px-4 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Add Team
            </button>
          </div>
          <div className="flex justify-end mt-6">
            <button
              type="button"
              onClick={() => setIsModalOpen(false)}
              className="mr-3 px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {currentHackathon ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default Hackathons;